import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';

const IDS = ['chinese_armchair', 'round_wooden_table_01', 'potted_plant_04', 'modern_ceiling_lamp_01'];

// Returns the authored scenes at their original glTF scale and transforms.
export async function loadInteriorAssets(loader = new GLTFLoader(), {basePath = '/assets/interior'} = {}) {
 const scenes = await Promise.all(IDS.map(async id => {
  try {
   const gltf = await loader.loadAsync(`${basePath}/${id}/${id}_1k.gltf`);
   const scene = gltf?.scene;
   if (!scene?.traverse) throw new Error('missing scene');
   let meshes = 0;
   scene.traverse(object => {
    if (!object.isMesh) return;
    meshes++;
    if (!object.geometry?.attributes?.uv) throw new Error('missing UVs');
    for (const material of (Array.isArray(object.material) ? object.material : [object.material])) {
     if (!material?.isMeshStandardMaterial) throw new Error('expected lit PBR material');
     // All six authored materials use these three images; GLTFLoader may
     // otherwise swallow failed image requests and return incomplete scenes.
     for (const key of ['map','normalMap','roughnessMap','metalnessMap']) {
      if (!material[key]?.isTexture) throw new Error(`missing texture ${key}`);
     }
    }
   });
   if (!meshes) throw new Error('missing meshes');
   return scene;
  } catch (error) {
   throw new Error(`Interior asset ${id} failed: ${error?.message ?? error}`, {cause:error});
  }
 }));
 return Object.fromEntries(IDS.map((id,i) => [id, scenes[i]]));
}
